import { styled } from '@mui/material/styles';
import { Link } from 'gatsby-theme-material-ui';

export default styled(Link)(({ theme }) => ({
  '&:focus, &:hover': {
    color: theme.palette.link.primary,
  },
}));
